module.exports = __webpack_public_path__ + "img/fewu1.3dae30ad.jpg";